/**
 * Auth Layout
 *
 * Layout for authentication pages (login, register, etc.)
 * Inspired by 3D SCI design with blue gradient background.
 */

import { Suspense } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { config } from '@/config';

export function AuthLayout() {
  const { pathname } = useLocation();
  const isOnboarding = pathname === '/onboarding';

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-gradient-to-b from-primary to-blue-600 px-4 py-12">
      {/* Logo */}
      <div className="absolute top-6 left-6">
        <Link to="/" className="flex items-center gap-2 text-xl font-bold text-white">
          {config.appName}
        </Link>
      </div>

      {/* Auth Card */}
      <div
        className={`w-full rounded-2xl bg-white p-8 shadow-xl ${
          isOnboarding ? 'max-w-3xl' : 'max-w-md'
        }`}
      >
        <Suspense
          fallback={
            <div className="flex items-center justify-center py-12">
              <Loader2 className="h-8 w-8 animate-spin text-primary" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </div>

      {/* Footer */}
      <footer className="mt-8 text-center text-white/70">
        <p className="text-sm">
          © {new Date().getFullYear()} {config.appName}. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default AuthLayout;
